// AI Generated
import { Component, Input } from '@angular/core';
import { PipeService } from '@client/app/filters/pipe-transformation.service';

@Component({
    selector: 'page-performance-audit-display-informative-request-chain',
    standalone: false,
    template: `
        <ul>
            <li class="py-2" *ngFor="let chain of chains; trackBy: trackByFn">
                <div [innerHTML]="getUrlSnippet(chain)"></div>
                <page-performance-audit-display-informative-request-chain
                    *ngIf="hasChildren(chain)"
                    [chains]="chain.children">
                </page-performance-audit-display-informative-request-chain>
            </li>
        </ul>
    `,
})
export class PagePerformanceAuditDisplayInformativeRequestChainComponent {
    @Input() chains: any;

    constructor (private pipeService: PipeService) {}

    getUrlSnippet (chain: any): string {
        const containerEl = document.createElement('div');
        const anchorEl = document.createElement('a');
        const spanEl = document.createElement('span');
        anchorEl.target = '_blank';
        anchorEl.href = chain.request.href || chain.request.url;
        if (anchorEl.pathname.length > 1) {
            anchorEl.innerText = anchorEl.pathname;

            spanEl.innerHTML = '&nbsp;(' + anchorEl.hostname + ')';
            spanEl.classList.add('text-grey');
        } else {
            anchorEl.innerText = anchorEl.hostname;
        }

        if (!this.hasChildren(chain)) {
            const strongEl = document.createElement('strong');
            const spanFileSizeEl = document.createElement('span');
            const spanMsEl = document.createElement('span');
            spanFileSizeEl.innerText = this.pipeService.get('monNumber')(chain.request.transferSize, '0.00 ib');
            spanMsEl.innerHTML =
                this.pipeService.get('monNumber')((chain.request.endTime - chain.request.startTime) * 1000, '0') + '&nbsp;ms';
            strongEl.innerHTML = '-&nbsp;' + spanMsEl.innerHTML + ',&nbsp;' + spanFileSizeEl.innerHTML;
            spanEl.innerHTML = spanEl.innerHTML + '&nbsp;' + strongEl.outerHTML;
        }

        containerEl.append(anchorEl);
        containerEl.append(spanEl);
        return containerEl.innerHTML;
    }

    hasChildren (chain: any): boolean {
        return Boolean(chain.children);
    }

    trackByFn (index: number, item: any): any {
        return index;
    }
}
